import { useRentalManagerUserPropertyArchiveV2WebApiHandler_archive } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import { DEFAULT_ARCHIVE_INVALIDATES } from '../../constants/InvalidateConstants';

import type { MutateOptions } from '@zg-rentals/react-query5';
import type { ListingAlias } from '@zg-rentals/ts-rental-manager-api-client';
import type { RentalManagerUserPropertyArchiveV2WebApiHandler_archive_Args } from '@zg-rentals/ts-rental-manager-api-client-react-query';

type ArchivePropertyOptions = Parameters<typeof useRentalManagerUserPropertyArchiveV2WebApiHandler_archive>[0];

type ArchivePropertyMutateOptions = MutateOptions<
  void,
  unknown,
  RentalManagerUserPropertyArchiveV2WebApiHandler_archive_Args
>;

/**
 * Archives a property and its dupes via /api/web/v2/users/properties/archive.
 *
 * Merges default `meta.invalidates` (plus any `meta.invalidates` you pass) and sets `meta.context`
 * for logging unless overridden.
 */
export const useArchiveProperty = (options: ArchivePropertyOptions = {}) => {
  const { meta: metaOverrides, ...restOptions } = options;

  const mutation = useRentalManagerUserPropertyArchiveV2WebApiHandler_archive({
    ...restOptions,
    meta: {
      ...metaOverrides,
      invalidates: [...DEFAULT_ARCHIVE_INVALIDATES, ...(metaOverrides?.invalidates ?? [])],
      context: {
        api: 'archive',
        details: 'useArchiveProperty',
        ...metaOverrides?.context,
      },
    },
  });

  const archiveProperty = (listingAlias: ListingAlias, mutateOptions?: ArchivePropertyMutateOptions) =>
    mutation.mutate({ postData: { listingAlias } }, mutateOptions);

  return { ...mutation, archiveProperty };
};
